import React, { FC, Fragment, useEffect, useState } from 'react';
import Price from 'components/lab-order/price/price.component';
import { LabConstuction } from 'models/order-input/lab-order';

type ConstructionTotalPriceProps = {
    construction: LabConstuction;
    warranty: boolean;
};
const ConstructionTotalPrice: FC<ConstructionTotalPriceProps> = ({ construction, warranty }) => {
    const [price, setPrice] = useState(0);

    useEffect(() => {
        if (!construction) return;
        const actionPrices = construction.actions.reduce((total, action) => {
            const priceWithVat = action.priceWithVat || 0;
            return total + priceWithVat;
        }, 0);
        const materialPrices = construction.materials.reduce((total, material) => {
            const priceWithVat = material.priceWithVat || 0;
            return total + priceWithVat;
        }, 0);
        setPrice(actionPrices + materialPrices);
    }, [construction, warranty]);

    return (
        <Fragment>
            <Price warranty={warranty} label="PRICE" price={price} />
        </Fragment>
    );
};

export default ConstructionTotalPrice;
